
import { createReducer, on } from '@ngrx/store';
import { setSelectedApplication, setAppList, setSelectedAppDetails, setCurrentUser, CurrentUser } from './app-state.actions';
import { UserAppResponse } from '../services/models/app-user.model';
import { ApplicationDetailsResponse } from '../services/models/application-details.model';

export interface AppState {
  selectedApplication: number | null;
  currentUser: CurrentUser | null;
  selectedAppDetails: ApplicationDetailsResponse;
  appList: UserAppResponse[];
}

export const initialState: AppState = {
  selectedApplication: null,
  currentUser: null,
  selectedAppDetails: null,
  appList: []
};

export const appReducer = createReducer(
  initialState,
  on(setSelectedApplication, (state, { applicationId }) => ({
    ...state,
    selectedApplication: applicationId
  })),
  on(setCurrentUser, (state, { user }) => ({
    ...state,
    currentUser: user
  })),

  on(setSelectedAppDetails, (state, { selectedAppDetails }) => ({
    ...state,
    selectedAppDetails: selectedAppDetails
  })),

  on(setAppList, (state, { appList }) => ({
    ...state,
    appList: appList
  }))
);
